import IntroduceIcon from '@/assets/img/introduce.jpeg';

import * as S from './style';

const IntroduceOwner = () => (
	<S.IntroduceOwnerContainer>
		<S.OwnerImage>
			<img src={IntroduceIcon} alt="introduce" />
		</S.OwnerImage>
		<S.OwnerContentBox>
			<S.OwnerTitleBox>
				<S.OwnerTitle>
					안녕하십니까?
					<br />
					사단법인 대한화장품학회 회장 황재성입니다.
				</S.OwnerTitle>
				<S.OwnerDescription>
					다사다난했던 2025년을 마무리하고, 희망찬 2026년 새해가 밝았습니다. 새로운 시작을 맞이하여 화장품 산업 관계자 여러분과 독자 여러분의 가정에 건강과
					행복이 가득하시기를 진심으로 기원합니다.
				</S.OwnerDescription>
				<S.OwnerDescription>
					지난 한 해 동안 우리 학회는 급변하는 글로벌 뷰티 시장의 흐름 속에서 K-Beauty의 혁신적인 기술력과 학문적 깊이를 더욱 확고히 다지고자 많은 노력을
					기울였습니다. <br />
					학회 회원과 산업 관계자 여러분의 적극적인 참여와 성원에 힘입어, 학문 분야의 세분화와 융합 연구 수요에 발맞춰 기존 5개 분과를 7개로 확대 개편하며 각
					분야의 전문성을 심화하는 기반을 마련하였습니다. <br />
					또한, 사단법인 전환에 따른 후속 조치로 학회를 공익기관으로 변경위해 정관 및 회원 규정 등 전체적인 규정을 정비하였습니다.
				</S.OwnerDescription>
				<S.OwnerDescription>
					새해 2026년에는 지난 성과를 발판 삼아, 우리 학회가 글로벌 학술 단체로 확고히 도약하고 한국 화장품 산업의 경쟁력 강화에 기여할 수 있도록 핵심 사업들을
					중점적으로 추진하고자 합니다. <br />
					무엇보다 학회지의 질적 수준을 높이기 위해 논문 투고 규정을 정비하고, 나아가 학회지가 KCI를 넘어 SCOPUS 나 SCI(E)등 국제적인 색인 데이터베이스에 등재될
					수 있도록 국문 학회지를 단계적으로 영문지로 전환하는 작업을 본격적으로 추진하여 연구 성과를 세계 무대에 알리는 교두보를 마련하겠습니다. <br />
					아울러 작년 2025년에 우리는 2032년 국제화장품기술자학회(IFSCC) 대회의 한국 유치를 위해 전력을 다했으나, 아쉽게도 뜻을 이루지 못했습니다. <br />
					그러나 이 유치 활동 과정에서 보여준 우리 학회와 K-Beauty의 잠재력은 전 세계에 깊은 인상을 남겼습니다. <br />이 소중한 경험을 바탕으로 목표를
					재정비하여, 2035년 IFSCC 유치에 성공할 수 있도록 지금부터 철저히 준비하고 모든 역량을 집중하겠습니다.
				</S.OwnerDescription>

				<S.OwnerDescription>2026년 한 해 동안에도 변함없는 성원과 관심을 부탁드립니다.</S.OwnerDescription>
				<S.OwnerDescription>감사합니다.</S.OwnerDescription>
			</S.OwnerTitleBox>
			<S.OwnerSign>
				<S.OwnerDescription>2026 년 01 월</S.OwnerDescription>
				<S.OwnerNameBox>
					<S.OwnerDescription>사단법인 대한화장품학회 회장</S.OwnerDescription>
					<S.OwnerName>
						<strong>황 재 성</strong>
						배상
					</S.OwnerName>
				</S.OwnerNameBox>
			</S.OwnerSign>
		</S.OwnerContentBox>
	</S.IntroduceOwnerContainer>
);

export default IntroduceOwner;
